import { updateTokens } from '../api/auth/updateTokens';
import { clientBL } from '../client/client.BL';

export const updateTokensOnMutate = async () =>
    clientBL.shouldUpdateTokensOnMutate() && (await updateTokens());
